import { apiServerRoutes } from "../constants/apiRoutes";
import {
  deleteAPICallServer,
  getAPICallServer,
  postAPICall,
  postAPICallServer,
} from "../utils/axios.util";

class DashboardService {
  async fetchListing(req: any) {
    const { type, page, searchString } = req.body;

    return getAPICallServer(
      `${apiServerRoutes.DASHBOARD_LISTING.replace(
        ":type",
        type
      )}?page=${page}&search=${searchString}&perPage=12`,
      req
    );
  }

  async ownerDashboard(req: any) {
    return getAPICallServer(apiServerRoutes.OWNER_DASHBOARD, req);
  }

  async ownerDashboardStats(req: any) {
    return postAPICallServer(apiServerRoutes.OWNER_DASHBOARD_STATS, req.body);
  }

  async ownerDashboardBookings(req: any) {
    return getAPICallServer(apiServerRoutes.OWNER_DASHBOARD_BOOKINGS, req);
  }

  async ownerDashboardPayouts(req: any) {
    return getAPICallServer(
      `${apiServerRoutes.OWNER_DASHBOARD_PAYOUTS}?page_no=${
        req?.body?.page || 1
      }&filter=2`,
      req
    );
  }

  async deleteEquipment(req: any) {
    return deleteAPICallServer(
      apiServerRoutes.DELETE_EQUIPMENT.replace(":id", req?.body?.id)
    );
  }
}

export default new DashboardService();
